import api from '../services/api';

export const getSettings = () => {
    return api.get('/settings').then((res) => res.data.data);
};
